import React from 'react'
import { Modal } from 'antd';
import { Button } from '@digital/ui';
import { useRecoilState, useRecoilValue } from 'recoil'
import { ordemCompraIdState, reloadVendorListState } from '../atoms'
import { enviarDdiFornecedor } from '@app/api/sas/ordemCompra';

const ButtonModalEnviarDdi = () => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);

    const onConcordar = () => {
        Modal.confirm({
            title: 'Confirmação Envio de Email',
            content: 'Você deseja enviar este e-mail?',
            cancelText: 'Não',
            onCancel: () => {
                enviarDdiFornecedor(ordemCompraId, false)
                    .then((data: any) => {
                        if (data) {
                            setReloadVendorList(!reloadVendorList);
                        }
                    })
            },
            okText: 'Sim',
            onOk: () => {
                enviarDdiFornecedor(ordemCompraId, true)
                    .then((data: any) => {
                        if (data) {
                            setReloadVendorList(!reloadVendorList);
                        }
                    })
            },
        });

    }

    return (
        <>
            <Button
                title='Enviar DDI'
                type='primary'
                onClick={() => {
                    Modal.confirm({
                        title: 'Confirmar envio',
                        content:
                            'Confirma envio de DDI?',
                        cancelText: 'Cancelar',
                        okText: 'Confirmar',
                        onOk: () => {
                            onConcordar();
                        },
                    });
                }}
            />
        </>
    )
}

export default ButtonModalEnviarDdi